import * as types from "./mutation_types";

export default {
  [types.SET_STATE](state, newState) {
    Object.assign(state, newState);
  },

  [types.SET_BUSINESS](state, business) {
    state.business = business;
  }
};
